<div class="watch-tutorial-container" *ngIf="tutorial">
    <div class="watch-tutorial">
        <div class="close" (click)="closeTutorial()"></div>
        <img src="/assets/images/tutorial_image.png" />
        <div class="tutorial-text mt-3">
            If you need help or got any questions regarding our app
        </div>
        <a [routerLink]="'/help'" target="_blank" class="btn btn-info mt-3">Watch Tutorial</a>
    </div>
</div>
<div class="preview align-self-center" [ngClass]="{'no-audio': isAllowedToShowPreview()}" [ngStyle]="{'height.px' : 360, 'width.px' : 360 * aspectRatio }">
    <div class="no-sound" *ngIf="!isAllowedToShowPreview()">
        <div class="no-sound-text">
            First step to work on new Storyboard<br />
            is to <span>upload audio</span> file
        </div>
    </div>
    <div class="readonly-layer" *ngIf="storyboard.read_only"></div>
    <preview-render [storyboard]="storyboard" [hidden]="!isAllowedToShowPreview()"></preview-render>
</div>



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/preview/preview.component.html